"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePicker = void 0;
exports.formatDate = _formatDate;
exports.parseDate = _parseDate;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));
require("react-day-picker/lib/style.css");
var _propTypes = require("prop-types");
var _DatePicker = require("./DatePicker.styled");
var DatePicker = exports.DatePicker = function DatePicker(_ref) {
  var id = _ref.id,
    _ref$format = _ref.format,
    format = _ref$format === void 0 ? 'MM-DD-YYYY' : _ref$format,
    dataTestId = _ref.dataTestId,
    disablePastDates = _ref.disablePastDates,
    value = _ref.value,
    onChange = _ref.onChange,
    title = _ref.title;
  return _react["default"].createElement(_DatePicker.DatePickerWrapper, {
    title: title,
    "data-testid": dataTestId
  }, _react["default"].createElement(_DayPickerInput["default"], {
    inputProps: {
      id: id,
      title: title
    },
    value: value,
    formatDate: function formatDate(date) {
      return _formatDate(date, format);
    },
    parseDate: function parseDate(str) {
      return _parseDate(str, format);
    },
    onDayChange: function onDayChange(date) {
      onChange && onChange(date);
    },
    dayPickerProps: {
      disabledDays: {
        before: disablePastDates ? new Date() : null
      }
    },
    placeholder: "".concat((0, _momentTimezone["default"])().format(format))
  }));
};
DatePicker.propTypes = {
  id: _propTypes.string,
  format: _propTypes.string,
  dataTestId: _propTypes.string,
  disablePastDates: _propTypes.bool,
  value: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  onChange: _propTypes.func,
  title: _propTypes.string
};
/**
 * @description Parses date from it's string equivalence
 * @param {string} dateString Date string
 * @param {string} format Date output format
 * @returns Date
 */
function _parseDate(dateString, format) {
  // Make sure the string in the input has the same length as the format
  if (dateString.length !== format.length) return undefined;
  var momentObject = (0, _momentTimezone["default"])(dateString, format);
  // Make sure the moment object is valid
  if (momentObject.isValid()) {
    return momentObject.toDate();
  }
  return undefined;
}

/**
 * @description Formats date object to date string.
 * @param {Date} date Date object to be formatted
 * @param {string} format Date output format
 * @returns Date
 */
function _formatDate(date, format) {
  return (0, _momentTimezone["default"])(date).format(format);
}